var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input__button",on:{"click":_vm.send}},[_vm._v("Send")])}
var staticRenderFns = []

export { render, staticRenderFns }